import styled from "styled-components"

import { Bounds, Box } from "../grid"
import { ReactComponent as BgSvg } from "../../images/fold-bg.svg"
import { colors, devices, header, weights } from "../../utils/styleVariables"
import { setColor } from "../../utils/styleFunctions"

const FoldContainer = styled(Bounds)`
  background-color: ${setColor(colors.coral)};
  margin-bottom: 100px;
  padding: 0 22px;

  @media (min-height: 350px) {
    padding: 40px 22px;
  }
  @media ${devices.mobile} and (min-height: 600px) {
    height: calc(85vh - ${header.mobileUpHeight});
    padding: 100px 22px;
  }
  @media ${devices.tablet} {
    align-items: flex-start;
    margin-top: 60px;
    padding: 0;
    background-color: transparent;
  }
`

const IllustrationContainer = styled(Box)`
  display: none;

  @media ${devices.tablet} {
    width: 50%;
    display: block;
  }
`

const FoldSvg = styled(BgSvg)`
  width: 100%;
  height: 100%;
  & rect {
    fill: ${setColor(colors.lightBlue, 0.6)} !important;
  }
`
const FoldBaloon = styled.div`
  @media ${devices.tablet} {
    z-index: -1;
    position: absolute;
    width: 140%;
    top: -200px;
    right: -180px;
  }
  @media (min-width: 1000px) {
    top: -215px;
  }
  @media (min-width: 1045px) {
    width: 130%;
  }
  @media ${devices.laptop} {
    top: -325px;
    right: -200px;
  }
  @media (min-width: 1500px) {
    width: 120%;
  }
  @media ${devices.monitor} {
    width: 115%;
    top: -300px;
    // padding-left: 50px;
  }
  @media (min-width: 2000px) {
    top: -400px;
    width: 110%;
  }
  @media (min-width: 2500px) {
    top: -650px;
  }
`
const FoldCopy = styled(Box)`
  position: relative;
  width: 100%;

  @media ${devices.tablet} {
    width: 50%;
  }

  & .copy-container {
    width: 90%;
    line-height: 1.2;
    margin: 10% 20px;

    @media ${devices.mobile} {
      margin: 0 20px 0 0;
    }
    @media ${devices.tablet} {
      width: 85%;
      margin: 0 8% 0 0;
    }
    @media (min-width: 1000px) {
      width: 75%;
    }
    @media ${devices.laptop} {
      width: 65%;
      margin: 30px 15% 0 0;
    }
    @media (min-width: 1400px) {
      margin: 0 15% 0 0;
    }
    @media (min-width: 1600px) {
      width: 55%;
      margin: 0px 12% 0 0;
    }
    @media (min-width: 1850px) {
      // width: 50%;
      // margin: 150px 12% 0 0;
    }
    @media (min-width: 2100px) {
      // margin: 150px 250px 0 0;
      // width: 40%;
    }
  }
  & .description {
    margin-top: 50px;
    margin-bottom: 40px;
    font-weight: ${weights.regular};
    font-size: 1.2rem;
    @media ${devices.mobile} {
      font-size: 1.6rem;
    }
    @media ${devices.monitor} {
    }
  }
  & .title {
    margin-bottom: 30px;
  }
`

export { FoldBaloon, FoldCopy, IllustrationContainer, FoldSvg, FoldContainer }
